import { formatMessage } from "utils/MessageContent";
import { Container } from "./styles";
import { TextQuoteProps } from "./types";

export function TextQuote({ quote }: TextQuoteProps) {
  return <Container dangerouslySetInnerHTML={{ __html: formatMessage(quote.body) }} />
}
